export const API_BASE_URL = process.env.GATSBY_APP_API_URL
export const ESIA_API_BASE_URL = process.env.GATSBY_APP_ESIA_API_URL
export const HALVA_API_BASE_URL = process.env.GATSBY_APP_HALVA_API_URL
